import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LegalPage from '../components/LegalPage';
import Seo from '../components/Seo';
import { useLang } from '../LangContext';
import { legalContent } from '../legalContent';

// Path → language map. The localized URL is the source of truth for
// which language to render. Switching language in the NavBar will
// navigate to the paired URL (see NavBar LEGAL_PAIRS).
const DE_PATHS = new Set(['/datenschutz', '/agb', '/impressum']);
const NL_PATHS = new Set(['/privacy', '/voorwaarden', '/colofon']);

export default function LegalRoute({ kind }) {
  const { lang } = useLang();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Effective language is derived from the URL, not the global context.
  // This lets the NavBar lang switch flow through to a real navigation
  // event (handled in NavBar.switchLang) instead of being silently
  // overridden by a useEffect here.
  const effLang = DE_PATHS.has(pathname) ? 'de' : NL_PATHS.has(pathname) ? 'nl' : lang;
  const doc = legalContent[kind]?.[effLang];

  const path = {
    privacy: effLang === 'de' ? '/datenschutz' : '/privacy',
    terms: effLang === 'de' ? '/agb' : '/voorwaarden',
    impressum: effLang === 'de' ? '/impressum' : '/colofon',
  }[kind];

  return (
    <>
      {doc && <Seo title={doc.title} description={doc.intro} path={path} lang={effLang} />}
      <LegalPage kind={kind} lang={effLang} onBack={() => navigate('/')} />
    </>
  );
}
